import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import ProposalValidator from "../../../../helpers/validators/ProposalValidator";
import InputMask from "react-input-mask";
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import Flatpickr from "react-flatpickr";
import { getInputClasses, setToOptionModel, formatToUSDate } from "../../../../helpers/helper";
import { Form, Modal, Button } from "react-bootstrap";
import * as clientService from "../../../../services/management/clientService";
import * as locationService from "../../../../services/management/locationService";
import * as projectTypeService from "../../../../services/companyData/projectTypeService";
import * as proposalService from "../../../../services/service/proposalService";
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
import Select from 'react-select'
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import * as referralSourceService from '../../../../services/companyData/referralSourceService';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import constants from "../../../../constants/constants";
import AddClientModal from './AddClientModal';
import AddLocationModal from './AddLocationModal';
import Chip from '@material-ui/core/Chip';
import * as projectService from '../../../../services/companyData/projectService';

const moment = require('moment');
var L = window.L;
L.mapquest.key = constants.MAPQUEST_KEY;

const ProposalDetailPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, history, proposalIdParam, isReadOnly } = props;
    const proposalId = proposalIdParam ? proposalIdParam : history.location.state == null ? null : history.location.state.proposalId;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setloading] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [selectedClient, setSelectedClient] = useState([]);
    const [locationList, setLocationList] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [projectTypeList, setProjectTypeList] = useState([]);
    const [selectedProjectType, setSelectedProjectType] = useState([])
    const [projectSubTypeList, setProjectSubTypeList] = useState();
    const [selectedProjectSubType, setSelectedProjectSubType] = useState([]);
    const [projectList, setProjectList] = useState();
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [referralList, setReferralList] = useState([]);
    const [selectedReferral, setSelectedReferral] = useState('');
    const [isAddClientModalVisible, setIsAddClientModalVisible] = useState(false);
    const [isAddLocationModalVisible, setIsAddLocationModalVisible] = useState(false);
    const [additionalEmailOptions, setAdditionalEmailOptions] = useState([]);
    const [additionalEmailText, setAdditionalEmailText] = useState("");
    const [additionalEmails, setAdditionalEmails] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [estimatedProjectNumber, setEstimatedProjectNumber] = useState("");

    const [proposalModel, setProposalModel] = useState({
        id: 0,
        projectNumber: '',
        clientId: null,
        locationId: null,
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        additionalEmails: '',
        projectName: '',
        projectTypeId: null,
        projectSubTypeId: null,
        description: '',
        expirationDate: formatToUSDate(moment()),
        referralSourceId: null,
        projectLocation: '',
        proposalProjectLocations: [],
    });

    useEffect(() => {
        if (proposalId) {
            setloading(true);
            proposalService.GetProposalById(proposalId).then(async res => {
                res.proposalProjectLocations = res.proposalProjectLocations ? res.proposalProjectLocations : [];
                if (res.additionalEmails) {
                    setAdditionalEmails([...new Set(res.additionalEmails.split(",").map(x => x.trim()))]);
                }
                setProposalModel(res);
                populateDropDowns(res);
                setloading(false);
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            });
            return;
        }

        fetchEstimatedProjectNumber();
        fetchProjects();
        populateDropDowns({
            clientId: null,
            locationId: null,
            projectTypeId: null,
            projectSubTypeId: null,
            referralSourceId: null,
            proposalProjects: null
        });
    }, []);

    const fetchEstimatedProjectNumber = () => {
        proposalService.GetEstimatedProjectNumber().then(res => {
            setEstimatedProjectNumber(res);
        })
    }

    const openMap = (enteredLocation) => {
        setIsModalOpen(true);
        let center = [30.388860788273128, -91.04902145401564];

        var geocoder = L.mapquest.geocoding();
        geocoder.geocode(enteredLocation == "" ? "ABBABA" : enteredLocation, (error, res) => {
            if (enteredLocation != "" && error != null) {
                var firstLocation = res.results[0].locations[0];
                firstLocation = firstLocation ? firstLocation.displayLatLng : null;
                if (firstLocation) {
                    center = [firstLocation.lat, firstLocation.lng];
                }
            }
            var map = L.mapquest.map('map', {
                center: center,
                layers: L.mapquest.tileLayer('map'),
                zoom: 12
            });
            if (center[0] !== 30.388860788273128) {
                var savedMarker = L.mapquest.textMarker(center, {
                    text: "Selected Location",
                    subtext: enteredLocation,
                    position: 'right',
                    type: 'marker',
                    icon: {
                        primaryColor: '#333333',
                        secondaryColor: '#333333',
                        size: 'sm'
                    }
                }).addTo(map);
            }

            L.mapquest.control().addTo(map);
            var geocodingControl = L.mapquest.geocodingControl({
                keepOpen: true
            });

            map.addControl(geocodingControl);

            geocodingControl.on('searchahead_selected', function (eventResponse) {
                formik.setFieldValue("projectLocation", eventResponse.result.displayString);
                if (savedMarker)
                    savedMarker.remove();
            }, (err) => {
                console.log("Error is ", err);
            });

            console.log("This is completed");
        });
    }

    const populateDropDowns = (savedProposal) => {
        fetchClientDropDown(savedProposal.clientId, savedProposal.locationId);
        fetchProjectTypeDropDown(savedProposal.projectTypeId, savedProposal.projectSubTypeId, savedProposal.proposalProjects);
        fetchReferralSourceDropDown(savedProposal.referralSourceId);
    }

    const fetchClientDropDown = (selectedClientId, selectedLocationId) => {
        clientService.getClients().then(clients => {
            setClientList(clients);
            if (selectedClientId) {
                fetchLocationDropDown(selectedClientId).then(locations => {
                    var clientSelected = clients.find(x => x.id == selectedClientId);
                    setSelectedClient(setToOptionModel(clientSelected.name, clientSelected.id));

                    var locationSelected = locations.find(x => x.id == selectedLocationId);
                    setSelectedLocation(setToOptionModel((locationSelected.businessName ? locationSelected.businessName + " - " : "") + locationSelected.address.address1 + ", " + locationSelected.address.city + ", " + locationSelected.address.state + ", " + locationSelected.address.zipCode, locationSelected.id));
                });
            }
        });
    }

    const fetchReferralSourceDropDown = (selectedReferralSourceId) => {
        referralSourceService.getReferralSources().then(refferals => {
            setReferralList(refferals.map(x =>
                setToOptionModel(x.name, x.id)
            ));
            if (selectedReferralSourceId) {
                var referralSelected = refferals.find(x => x.id == selectedReferralSourceId);
                setSelectedReferral(setToOptionModel(referralSelected.name, referralSelected.id))
            }
        })
    }

    const fetchProjects = () => {
        return projectService.getProjects().then(res => {
            setAllProjects(res);

            return res;
        })
    }

    const fetchProjectTypeDropDown = (selectedProjectTypeId, selectedProjectSubTypeId, proposalProjects) => {
        projectTypeService.getProjectTypes().then(projectTypes => {
            setProjectTypeList(projectTypes);
            if (selectedProjectTypeId) {
                fetchProjectSubTypeDropDown(selectedProjectTypeId).then(projectSubTypes => {
                    var projectTypeSelected = projectTypes.find(x => x.id == selectedProjectTypeId);
                    if (projectTypeSelected) {
                        setSelectedProjectType(setToOptionModel(projectTypeSelected.name, projectTypeSelected.id));
                    }

                    var projectSubTypeSelected = projectSubTypes.find(x => x.id == selectedProjectSubTypeId);
                    if (projectSubTypeSelected) {
                        setSelectedProjectSubType(setToOptionModel(projectSubTypeSelected.name, projectSubTypeSelected.id));
                    }

                    return projectSubTypeSelected.id;
                }).then(res => {
                    fetchProjects().then(projs => {
                        handleProjectSubTypeChange(selectedProjectTypeId, res, projs);
                        if (proposalProjects) {
                            let tempArr = [];
                            proposalProjects.forEach(x => {
                                var project = projs.find(a => a.id == x.projectId);
                                if (project)
                                    tempArr.push(setToOptionModel(project.name, project.id));
                            });

                            setSelectedProjects(tempArr);
                        }
                    })
                });
            }
        });
    }

    const fetchLocationDropDown = (clientId) => {
        clientService.getAllClientEmails(clientId).then(res => {
            if (res) {
                setAdditionalEmailOptions([...new Set(res.split(",").map(x => x.trim()))]);
            }
        });
        if (clientId) {
            return locationService.getLocations(clientId).then(res => {
                setLocationList(res.map(x =>
                    setToOptionModel((x.businessName ? x.businessName + " - " : "") + x.address.address1 + ", " + x.address.city + ", " + x.address.state + ", " + x.address.zipCode, x.id)
                ));

                return res;
            })
        }
    }

    const fetchProjectSubTypeDropDown = (projectTypeId) => {
        if (projectTypeId) {
            return projectTypeService.getProjectTypeById(projectTypeId).then(res => {
                let subTypes = res.projectSubTypes;
                setProjectSubTypeList(subTypes.map(x =>
                    setToOptionModel(x.name, x.id)
                ));

                return subTypes;
            });
        }
    }

    const handleProjectSubTypeChange = (projectTypeId, projectSubTypeId, projs) => {
        let tempProjects = [...projs];
        tempProjects = tempProjects.filter(x => x.projectTypeId == projectTypeId && x.projectSubTypeId == projectSubTypeId);

        setProjectList(tempProjects.map(x => setToOptionModel(x.name, x.id)));
    }

    const formik = useFormik({
        initialValues: proposalModel,
        enableReinitialize: true,
        validationSchema: ProposalValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            if (selectedProjects.length === 0) {
                showAlert({ message: "Please select at least one project before you submit.", variant: 'error' });
                setSubmitting(false);
                return;
            }

            saveProposal(values, setSubmitting);
        }
    });

    const saveProposal = (values, setSubmitting) => {
        proposalService.SaveProposal({ ...values, proposalProjects: selectedProjects.map(x => { return { proposalId: proposalModel.id, projectId: x.value } }), additionalEmails: additionalEmails.join(",") }).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            if (proposalIdParam) {
                setSubmitting(false);
            } else {
                history.push('/services/manage-proposal/' + res.proposalId);
            }
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
            setSubmitting(false);
        })
    }

    const handleModalClose = () => {
        setIsModalOpen(false);
    }

    const clientAndLocationRegisterHandler = (client) => {
        populateDropDowns({
            clientId: client.clientId,
            locationId: client.locationId,
            projectTypeId: null,
            projectSubTypeId: null,
            referralSourceId: null,
        });

        setProposalModel({
            ...proposalModel,
            clientId: client.clientId,
            locationId: client.locationId,
            contactName: client.name,
            contactPhone: client.phone,
            contactEmail: client.email,
        })
        setIsAddClientModalVisible(false);
        setIsAddLocationModalVisible(false);
    }

    const addAdditionalEmails = (email) => {
        if (email.length === 0) {
            return;
        }
        let temp = [...additionalEmails];
        if (temp.filter(x => x == email).length == 0) {
            temp.push(email);
        }

        setAdditionalEmails(temp);
        setAdditionalEmailText("");
    }

    const removeAdditionalEmail = (index) => {
        let temp = [...additionalEmails];
        temp.splice(index, 1);

        setAdditionalEmails(temp);
    }

    const removeProposalProjectLocation = (index) => {
        let locations = [...formik.values.proposalProjectLocations];
        locations.splice(index, 1);

        formik.setFieldValue("proposalProjectLocations", locations);
    }

    return (
        <>
            {
                !proposalModel.id &&
                <>
                    <AddClientModal
                        isVisible={isAddClientModalVisible}
                        closeModal={() => setIsAddClientModalVisible(false)}
                        clientRegisterHandler={clientAndLocationRegisterHandler}
                    />
                    <AddLocationModal
                        client={selectedClient}
                        isVisible={isAddLocationModalVisible}
                        closeModal={() => setIsAddLocationModalVisible(false)}
                        locationRegisterHandler={clientAndLocationRegisterHandler}
                    />
                </>
            }

            <Modal size="lg" show={isModalOpen} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Search Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="card-body pt-0">
                        <div className="row mb-lg-7">
                            {
                                formik.values.projectLocation ?
                                    <h4 className="fw-600">Current Location: <span className="fw-400">{formik.values.projectLocation}</span></h4>
                                    : <></>
                            }
                        </div>
                        <div className="row" id="map" style={{ height: '36vh' }}></div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 d-flex justify-content-between">
                        <Button disabled={!formik.values.projectLocation} className="btn-info" variant="primary" onClick={() => {
                            window.open("https://www.google.com/maps/dir//" + formik.values.projectLocation.replace(' ', '+'), '_blank')
                        }}>
                            View in google maps
                        </Button>
                        <div className="">
                            <Button variant="secondary" onClick={handleModalClose}>
                                Close
                            </Button>

                            <button
                                type="submit"
                                className="btn btn-success mr-2 ml-2"
                                onClick={handleModalClose}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
            <form
                className="card card-custom card-stretch"
                onSubmit={formik.handleSubmit}
            >
                {loading && <ModalProgressBar />}
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            {proposalId ? "Edit" : "Add"} Proposal
                        </h3>
                        <span className="text-muted font-weight-bold fz-xs mt-1">
                            Please fill out the form below. Fields marked as <code>*</code> are required.
                        </span>
                    </div>
                    {
                        // isReadOnly !== true &&
                        <div className="card-toolbar">
                            <button
                                type="submit"
                                className="btn btn-info mr-2"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formik.submitForm();
                                }}
                                disabled={
                                    formik.isSubmitting || (formik.touched && !formik.isValid)
                                }
                            >
                                {"Save Changes"}
                                {formik.isSubmitting}
                            </button>

                            <Link
                                to="/services/proposals"
                                className="btn btn-danger"
                            >
                                Cancel
                            </Link>
                        </div>
                    }

                </div>
                <fieldset disabled={isReadOnly}>
                    <div className="form">
                        <div className="card-body">
                            {
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        Project Number
                                    </label>
                                    <div className="col-lg-9 col-xl-6">
                                        <div className="input-group input-group-lg input-group-solid">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fa fa-hashtag"></i>
                                                </span>
                                            </div>
                                            {proposalModel.id > 0 ? <input
                                                type="text"
                                                readOnly
                                                value={proposalModel.projectNumber}
                                                className={`form-control form-control-lg form-control-solid`}
                                                name="projectNumber"
                                            /> :
                                                <>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={estimatedProjectNumber}
                                                        className={`form-control form-control-lg form-control-solid`}
                                                    />
                                                </>}
                                        </div>
                                        {proposalModel.id === 0 && <span className="form-text text-muted">This is an estimated project number. Actual Project number may vary after you save the changes</span>}
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <label className="col-xl-3"></label>
                                <div className="col-lg-9 col-xl-6 d-flex w-100 justify-content-between">
                                    <h5 className="mb-6 fz-md fw-700 c-primary">Client Info</h5>
                                    {
                                        !proposalModel.id &&
                                        <button onClick={() => setIsAddClientModalVisible(true)} type="button" className="btn btn-primary btn-sm" style={{ height: 'fit-content' }}>Add New Client</button>
                                    }
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Client*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <Select
                                        value={selectedClient}
                                        options={clientList.map(x => setToOptionModel(x.name, x.id))}
                                        onChange={selectedOption => {
                                            setSelectedLocation([]);
                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                            setSelectedClient(selectedOption);
                                            fetchLocationDropDown(selectedOption.value);
                                            formik.setFieldValue("clientId", selectedOption.value);
                                        }}
                                        className={`${getInputClasses(formik, "clientId")}`}
                                        name="clientId"
                                        isDisabled={isReadOnly}
                                        placeholder="Select Client"
                                    />
                                    {formik.touched.clientId && formik.errors.clientId ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.clientId}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Location*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    {
                                        formik.values.clientId && !proposalModel.id &&
                                        <div className="w-100 d-flex justify-content-end mb-5">
                                            <button onClick={() => setIsAddLocationModalVisible(true)} type="button" className="btn btn-primary btn-sm" style={{ height: 'fit-content' }}>Add New Location</button>
                                        </div>
                                    }

                                    <Select
                                        value={selectedLocation}
                                        options={locationList}
                                        onChange={selectedOption => {
                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                            setSelectedLocation(selectedOption);
                                            formik.setFieldValue("locationId", selectedOption.value);
                                            locationService.getLocationById(selectedOption.value).then(res => {
                                                formik.setFieldValue("contactName", res.contactName);
                                                formik.setFieldValue("contactPhone", res.contactPhone);
                                                formik.setFieldValue("contactEmail", res.contactEmail);
                                            })
                                        }}
                                        className={`${getInputClasses(formik, "locationId")}`}
                                        name="locationId"
                                        isDisabled={isReadOnly}
                                        placeholder="Select Location"
                                    />
                                    {formik.touched.locationId && formik.errors.locationId ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.locationId}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-xl-3"></label>
                                <div className="col-lg-9 col-xl-6">
                                    <h5 className="mt-lg-10 mt-lg-10 mb-6 fz-md fw-700 c-primary">Contact Details</h5>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Name*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} /> </span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="John Doe"
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactName")}`}
                                            name="contactName"
                                            {...formik.getFieldProps("contactName")}
                                        />
                                    </div>
                                    {formik.touched.contactName && formik.errors.contactName ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.contactName}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Email Address
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-at.svg")} /> </span>
                                            </span>
                                        </div>
                                        <input
                                            type="email"
                                            placeholder="john.doe@aes.net"
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactEmail")}`}
                                            name="contactEmail"
                                            {...formik.getFieldProps("contactEmail")}
                                        />
                                    </div>
                                    {formik.touched.contactEmail && formik.errors.contactEmail ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.contactEmail}
                                        </div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Additional Emails
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <Select
                                            value={null}
                                            id="select-type-additional-emails"
                                            options={additionalEmailOptions.map(x => setToOptionModel(x, x))}
                                            onChange={selectedOption => {
                                                addAdditionalEmails(selectedOption.value)
                                            }}
                                            onInputChange={(val) => {
                                                if (val != "")
                                                    setAdditionalEmailText(val);
                                            }}
                                            name="projectTypeId"
                                            isDisabled={isReadOnly}
                                            placeholder="Select or Type Additional Emails Type"
                                        />
                                        {
                                            !isReadOnly &&
                                            <div className="input-group-append">
                                                <span
                                                    onClick={() => {
                                                        addAdditionalEmails(additionalEmailText)
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                    className={`label label-xl mr-2 label-inline label-light-success`}
                                                >
                                                    Add
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    {
                                        additionalEmails.map((email, index) => <Chip
                                            key={index}
                                            label={email}
                                            style={{ margin: '5px' }}
                                            onDelete={() => isReadOnly !== true ? removeAdditionalEmail(index) : {}}
                                            color='secondary'
                                        />)
                                    }
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Contact Phone
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Adress-book1.svg")} /> </span>                                    </span>
                                        </div>
                                        <InputMask
                                            mask="(999) 999-9999"
                                            type="text"
                                            placeholder="(123)-456-789"
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactPhone")}`}
                                            name="contactPhone"
                                            {...formik.getFieldProps("contactPhone")}
                                        />
                                    </div>
                                    {formik.touched.contactPhone && formik.errors.contactPhone ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.contactPhone}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-xl-3"></label>
                                <div className="col-lg-9 col-xl-6">
                                    <h5 className="mt-lg-10 mt-lg-10 mb-6 fz-md fw-700 c-primary">Project Details</h5>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Project Name*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <input
                                        type="text"
                                        placeholder="Asbestos Professional Services"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "projectName")}`}
                                        name="projectName"
                                        {...formik.getFieldProps("projectName")}
                                    />
                                    {formik.touched.projectName && formik.errors.projectName ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.projectName}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Project Type*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <Select
                                        value={selectedProjectType}
                                        options={projectTypeList.map(x => setToOptionModel(x.name, x.id))}
                                        onChange={selectedOption => {
                                            setSelectedProjectSubType([]);
                                            setSelectedProjects([]);
                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                            setSelectedProjectType(selectedOption);
                                            fetchProjectSubTypeDropDown(selectedOption.value);
                                            formik.setFieldValue("projectTypeId", selectedOption.value);
                                        }}
                                        className={`${getInputClasses(formik, "projectTypeId")}`}
                                        name="projectTypeId"
                                        placeholder="Select Project Type"
                                        isDisabled={isReadOnly}
                                    />
                                    {formik.touched.projectTypeId && formik.errors.projectTypeId ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.projectTypeId}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Project Sub Type*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <Select
                                        value={selectedProjectSubType}
                                        options={projectSubTypeList}
                                        onChange={selectedOption => {
                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                            setSelectedProjectSubType(selectedOption);
                                            handleProjectSubTypeChange(selectedProjectType.value, selectedOption.value, allProjects);
                                            formik.setFieldValue("projectSubTypeId", selectedOption.value);
                                        }}
                                        className={`${getInputClasses(formik, "projectSubTypeId")}`}
                                        name="projectSubTypeId"
                                        placeholder="Select Project Sub Type"
                                        isDisabled={isReadOnly}
                                    />
                                    {formik.touched.projectSubTypeId && formik.errors.projectSubTypeId ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.projectSubTypeId}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Projects*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        value={selectedProjects}
                                        options={projectList}
                                        onChange={selectedOption => {
                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                            setSelectedProjects(selectedOption);
                                        }}
                                        name="projects"
                                        placeholder="Select Projects"
                                    // isDisabled={isReadOnly}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Project Location*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            type="text"
                                            placeholder="Type address manually or click search"
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "projectLocation")}`}
                                            name="projectLocation"
                                            {...formik.getFieldProps("projectLocation")}
                                        />

                                        {
                                            !isReadOnly &&
                                            <>
                                                <div className="input-group-append">
                                                    <span
                                                        onClick={() => openMap(formik.values.projectLocation)}
                                                        style={{ cursor: 'pointer' }}
                                                        className={`label label-xl mr-2 label-inline label-light-info`}
                                                    >
                                                        Search
                                                    </span>
                                                </div>
                                                <div className="input-group-append">
                                                    {
                                                        proposalId ?
                                                            <span
                                                                onClick={() => {
                                                                    //now replaces the location
                                                                    let tempLocation = [...formik.values.proposalProjectLocations];
                                                                    console.log(tempLocation)
                                                                    if (tempLocation.length) {
                                                                        var location = { ...tempLocation[0], projectLocation: formik.values.projectLocation };
                                                                        console.log(location);
                                                                        formik.setFieldValue("projectLocation", '');
                                                                        formik.setFieldValue("proposalProjectLocations", [{ ...location }]);
                                                                    }
                                                                }}
                                                                style={{ cursor: 'pointer' }}
                                                                className={`label label-xl mr-2 label-inline label-light-primary`}
                                                            >
                                                                Update
                                                            </span>
                                                            :
                                                            <span
                                                                onClick={() => {
                                                                    let locations = [...formik.values.proposalProjectLocations];
                                                                    locations.push({
                                                                        id: 0,
                                                                        proposalId: proposalModel.id,
                                                                        projectLocation: formik.values.projectLocation
                                                                    });
                                                                    formik.setFieldValue("projectLocation", '');
                                                                    formik.setFieldValue("proposalProjectLocations", locations);
                                                                }}
                                                                style={{ cursor: 'pointer' }}
                                                                className={`label label-xl mr-2 label-inline label-light-primary`}
                                                            >
                                                                Add
                                                            </span>
                                                    }
                                                </div>
                                                <div className="input-group-append">
                                                    <span
                                                        onClick={() => formik.setFieldValue("projectLocation", '')}
                                                        style={{ cursor: 'pointer' }}
                                                        className={`label label-xl mr-2 label-inline label-light-danger`}
                                                    >
                                                        Clear
                                                    </span>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    {proposalId ? <span className="form-text text-muted">Please type the new location first and then click update to update the current location.</span> : <span className="form-text text-muted">Please make sure you click add after entering the location.</span>}
                                    <>
                                        {
                                            formik.values.proposalProjectLocations.map((location, index) => (
                                                <Chip
                                                    variant="outlined"
                                                    className="mt-3"
                                                    key={index}
                                                    label={location.projectLocation}
                                                    style={{ margin: '5px' }}
                                                    onDelete={() => isReadOnly !== true ? removeProposalProjectLocation(index) : {}}
                                                    color='primary'
                                                />
                                            ))

                                        }
                                    </>
                                    {formik.touched.proposalProjectLocations && formik.errors.proposalProjectLocations ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.proposalProjectLocations}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Description
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <Form.Control as="textarea" rows="5"
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "description")}`}
                                            name="description"
                                            {...formik.getFieldProps("description")}
                                        />
                                    </div>
                                    {formik.touched.description && formik.errors.description ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.description}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Expiry Date*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <Flatpickr
                                        placeholder="MM/DD/YYYY"
                                        options={{
                                            dateFormat: "m/d/Y"
                                        }}
                                        value={formatToUSDate(formik.getFieldProps("expirationDate").value)}
                                        onChange={date => {
                                            formik.setFieldValue("expirationDate", formatToUSDate(date[0]));
                                        }}
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "expirationDate")}`}
                                    />
                                    {formik.touched.expiryDate && formik.errors.expiryDate ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.expiryDate}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-xl-3"></label>
                                <div className="col-lg-9 col-xl-6">
                                    <h5 className="mt-lg-10 mt-lg-10 mb-6 fz-md fw-700 c-primary">Additional Info</h5>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Referral Source*
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <Select
                                        value={selectedReferral}
                                        options={referralList}
                                        onChange={selectedOption => {
                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                            setSelectedReferral(selectedOption);
                                            formik.setFieldValue("referralSourceId", selectedOption.value);
                                        }}
                                        className={`${getInputClasses(formik, "referralSourceId")}`}
                                        name="referralSourceId"
                                        placeholder="Select a referral source"
                                        isDisabled={isReadOnly}
                                    />
                                    {formik.touched.referralSourceId && formik.errors.referralSourceId ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.referralSourceId}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>
        </>
    )
}

export default connect(null, { ...alert.actions, ...confirmModal.actions })(ProposalDetailPage);